/** @format */

import React, { PureComponent, useCallback, useState } from 'react';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FilterManager } from '../../modules/filter/FilterManager';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import PaperedTable from '../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import Pager from '../../components/Adescom/PagerRange';
import { TableFooter } from '@material-ui/core';
import FilterList from '../../components/Filter/FilterList';
import { PlatformUserCollectionInterface } from '../../interfaces/platform/PlatformUserCollectionInterface';
import { platformUserConstants } from '../../modules/platformuser/actions';
import { PlatformUserListTable } from './PlatformUserListTable';
import FabAddButton from '../../components/Buttons/FabAddButton';
import { history } from '../../core/history';
import AlertInfo from '../../components/Info/AlertInfo';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { platformUserDefinedRolesToGroupsConstants } from '../../modules/platformGroups/reducers';
import PlatformUserDefinedRolesInterface from '../../interfaces/platform/PlatformUserDefinedRolesInterface';
import { PlatformUserDefinedRolessCollectionInterface } from '../../interfaces/api/PlatformUserDefinedRolessCollectionInterface';
import { NotificationHelper } from '../../helpers/NotificationHelper';

interface PlatformUserListStateInterface {
    platformUsers: PlatformUserCollectionInterface | null;
    orders: Array<Order>;
    filters: Array<Filter>;
    showClearFilterButton: boolean;
    searchSendWithFitler: boolean;
    activeRow: number;
    alert: null | React.ReactElement;
    userPermissionGroupUri: string;
    userPermissionGroups: PlatformUserDefinedRolessCollectionInterface | null;
    afterFirstLoad: boolean;
}

interface PlatformUserListProps extends ListPropsInterface {
    match: any;
}

class PlatformUserList extends PureComponent<PlatformUserListProps, PlatformUserListStateInterface> {
    private readonly loaderCall: ItemLoaders;
    private filterManage: FilterManager;
    private itemLoaders: ItemLoaders;

    constructor(props: PlatformUserListProps, context: PlatformUserListStateInterface) {
        super(props, context);

        this.state = {
            platformUsers: null,
            orders: [],
            filters: [{ name: 'exists[createdByPlatformUserId]', value: true }],
            activeRow: 0,
            searchSendWithFitler: false,
            showClearFilterButton: false,
            alert: null,
            userPermissionGroupUri: '/platform_user_defined_roles',
            userPermissionGroups: null,
            afterFirstLoad: false,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.filterManage = new FilterManager();
        this.itemLoaders = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {
            this.firstLoad();
            this.loadPermissionGroups();
        });
    }

    componentDidUpdate(prevProps: Readonly<PlatformUserListProps>, prevState: Readonly<PlatformUserListStateInterface>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
        });
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    setDefaultFilter = (callback: () => void): void => {
        this.setState(
            {
                showClearFilterButton: false,
                orders: [{ name: 'id', value: 'desc' }],
                filters: [
                    { name: 'platformResellerId', value: this.props.match.params.parentResellerId },
                    { name: 'exists[createdByPlatformUserId]', value: true },
                ],
                afterFirstLoad: false,
            },
            (): void => {
                callback();
                this.firstLoad();
            }
        );
    };

    firstLoad = (): void => {
        const { filters, orders, showClearFilterButton } = this.state;
        const { dispatch, showMainLoader } = this.props;

        let deletedKeyExist = false;
        let accountBlockedKeyExist = false;

        let preparedFilters = filters.map((el) => {
            // We should swap values due to misleading names
            if (el.name === 'allowGenericLogin') {
                if (el.value === 'false') {
                    return { name: 'allowGenericLogin', value: 'true' };
                }
                if (el.value === 'true') {
                    return { name: 'allowGenericLogin', value: 'false' };
                }
            }

            // If user manually change these properties we should mark them
            if (el.name === 'accountBlocked') {
                accountBlockedKeyExist = true;
            }

            if (el.name === 'deleted') {
                deletedKeyExist = true;
            }

            return el;
        });

        // If we do not found this properties in map above we should set those values to false.
        // With different filters set we should disable visibility of records for deleted and blocked users
        if (!deletedKeyExist) {
            preparedFilters = [...preparedFilters, { name: 'deleted', value: false }];
        }

        if (!accountBlockedKeyExist) {
            preparedFilters = [...preparedFilters, { name: 'accountBlocked', value: false }];
        }
        showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_users')),
            platformUserConstants.LIST,
            preparedFilters,
            orders,
            (items: PlatformUserCollectionInterface): void => {
                this.setState({
                    platformUsers: items,
                    searchSendWithFitler: showClearFilterButton,
                    afterFirstLoad: true,
                });
                showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    loadPermissionGroups = (uri?: string): void => {
        if (!uri) {
            uri = FormGeneralHelper.getPath(this.state.userPermissionGroupUri);
        }
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(uri),
            platformUserDefinedRolesToGroupsConstants.LIST,
            [{ name: 'loadAllRoles', value: true }],
            [{ name: 'mainname', value: 'asc' }],
            (data: PlatformUserDefinedRolessCollectionInterface) => {
                this.setState((prevState) => ({ ...prevState, userPermissionGroups: data }));
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    };

    paginationCallbackFunction = (uri: string): void => {
        const { showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            platformUserConstants.LIST,
            (items: PlatformUserCollectionInterface): void => {
                this.setState({ platformUsers: items });
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    addCallback = (): void => {
        const redirectUri = FormGeneralHelper.getRouteUrl('/platform-user-add/' + this.props.match.params.parentResellerId);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.push(redirectUri);
    };

    editCallback = (data: { uri: string }): void => {
        const redirectUri = FormGeneralHelper.getRouteUrl('/platform-user-edit/' + data.uri);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.push(redirectUri, { platformResellerId: this.props.match.params.parentResellerId });
    };

    deleteCallback = (data: { uri: string }): void => {
        this.setState({
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.deleteConfirmed({ uri: data.uri });
                    }}
                    onCancel={this.deleteCancelled}
                    confirmBtnText={'general:common.delete'}
                    cancelBtnText={'general:common.cancel'}
                    content="platform_user:a.confirm_delete_user"
                />
            ),
        });
    };

    discardCertificatesCallback = (data: any): void => {
        this.setState({
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.discardConfirmed(data);
                    }}
                    onCancel={this.deleteCancelled}
                    confirmBtnText={'auth:certificate.discard'}
                    cancelBtnText={'general:common.cancel'}
                    content="auth:certificate.confirm_discard"
                    valueObject={{ name: data.platformUser.personName, username: data.platformUser.username }}
                />
            ),
        });
    };

    discardConfirmed = (data: any): void => {
        this.itemLoaders.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/certification_requests/reject/' + data.platformUser.id)),
            platformUserConstants.DELETE,
            {},
            (data: any) => {
                this.setState({ alert: null }, () => {
                    // this.clearFilter();
                    const { dispatch } = this.props;
                    dispatch({
                        type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                        clearAll: true,
                    });
                    this.setDefaultFilter(this.firstLoad);
                });
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: true }
        );
    };

    deleteCancelled = (): void => {
        this.setState({ alert: null });
    };

    deleteConfirmed = (data: { uri: string }): void => {
        const { dispatch } = this.props;

        this.itemLoaders.deleteWithCallback(
            FormGeneralHelper.getByUri(data.uri),
            platformUserConstants.DELETE,
            (data: any) => {
                console.log(data);
                if (data && data.status === 204) {
                    NotificationHelper.notifySuccess('platform_user:a.delete_success', dispatch);
                    this.setState({ alert: null }, () => {
                        // this.clearFilter();
                        const { dispatch } = this.props;
                        dispatch({
                            type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                            clearAll: true,
                        });
                        this.setDefaultFilter(this.firstLoad);
                    });
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: true, dispatchErrorAfterCallback: true },
            { disableDefaultNotification: true }
        );
    };

    blockConfirmed = (data: { uri: string }, block = false): void => {
        this.setState({ alert: null });
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.itemLoaders.putWithCallback(
            FormGeneralHelper.getByUri(data.uri),
            platformUserConstants.SAVE_ITEM,
            {
                accountBlocked: block,
            },
            () => {
                this.setState({ alert: null }, () => {
                    // this.clearFilter();
                    const { dispatch } = this.props;
                    dispatch({
                        type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                        clearAll: true,
                    });
                    this.setDefaultFilter(this.firstLoad);
                });
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: true }
        );
    };

    blockCallback = (data: { uri: string }): void => {
        this.setState({
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.blockConfirmed(data, true);
                    }}
                    onCancel={(): void => {
                        this.setState({ alert: null });
                    }}
                    confirmBtnText={'platform_user:a.block'}
                    cancelBtnText={'general:common.cancel'}
                    content="platform_user:a.confirm_block_user"
                />
            ),
        });
    };

    unblockCallback = (data: { uri: string }): void => {
        this.setState({
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.blockConfirmed(data, false);
                    }}
                    onCancel={(): void => {
                        this.setState({ alert: null });
                    }}
                    confirmBtnText={'platform_user:a.unblock'}
                    cancelBtnText={'general:common.cancel'}
                    content="platform_user:a.confirm_unblock_user"
                />
            ),
        });
    };

    render(): React.ReactNode {
        const { classes } = this.props;
        const { showClearFilterButton, platformUsers, filters, orders, activeRow, userPermissionGroups } = this.state;
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color={'primary'}
                                        size={'lg'}
                                        label="general:common.search"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color={'primary'}
                                            size={'lg'}
                                            label="general:common.clear"
                                        />
                                    )}
                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        {platformUsers && userPermissionGroups && (
                            <PlatformUserListTable
                                platformUsers={platformUsers['hydra:member']}
                                userPermissionGroups={userPermissionGroups['hydra:member']}
                                editCallback={this.editCallback}
                                deleteCallback={this.deleteCallback}
                                blockCallback={this.blockCallback}
                                unblockCallback={this.unblockCallback}
                                discardCertificatesCallback={this.discardCertificatesCallback}
                                classes={classes}
                                setActiveRow={this.setActiveRow}
                                activeRow={activeRow}
                                firstLoad={this.firstLoad}
                                updateOrderList={this.updateOrderList}
                                updateFilterList={this.updateFilterList}
                                filters={filters}
                                orders={orders}
                            />
                        )}
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={10}>
                                    {platformUsers && platformUsers['hydra:view'] && (
                                        <Pager callback={this.paginationCallbackFunction} views={platformUsers} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                </GridItem>
                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_USER_ACCOUNT_ADMIN) && <FabAddButton callback={this.addCallback} />}
                {this.state.alert}
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    console.log(state);
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(oplAppStyle))(PlatformUserList);
